module.exports = __webpack_public_path__ + "img/ja-box.e29e00ed.png";